import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useSelector, shallowEqual } from 'react-redux';
import { Spin } from 'antd';
import { useAuth } from './AuthProvider';
import { selectAuth } from '@/redux/selector';

export const ProtectedRoute = ({ children }) => {
    const location = useLocation();
    const { company, user, superUser } = useSelector(selectAuth, shallowEqual);
    const { isAuthenticated, loading } = useAuth();
    
    if (loading) {
        return <Spin spinning={loading} />;
    }

    if (isAuthenticated) {
        if (location.pathname === '/login' || location.pathname === '/') {
            if (user) {
                if (company?.id) {
                    return (<Navigate to={'/dashboard'} state={{ from: location }} replace />);
                } else {
                    return (<Navigate to={'/masters/company/alter'} state={{ from: location }} replace />);
                }
            } else if (superUser) {
                return (<Navigate to={'/dashboard'} state={{ from: location }} replace />);
            }
        } else if (user?.id && !company?.id && location.pathname !== '/masters/company/alter') {
            return (<Navigate to={'/masters/company/alter'} state={{ from: location }} replace />);
        }
    } else if (!isAuthenticated && location.pathname !== '/login') {
        return (<Navigate to={'/login'} state={{ from: location }} replace />);
    }
    return children;
};